import { Typography } from "@mui/material";
import { KeyboardArrowRightRounded} from "@mui/icons-material";

const Info = ({ children }) => {
  return (
    <Typography
      variant="body1"
      color="black"
      textAlign="left"
      sx={{ display: "flex", alignItems: "center", mt: 2}}
    >
      <KeyboardArrowRightRounded
        sx={{ verticalAlign: "top", color: "primary.main" }}
      />
      {children}
    </Typography>
  );
};

const DevInfo = () => {
  return (
    <>
      <Info> Amirhossein Mohazzab </Info>
      <Info>
        ahm.mohazzab@gmail.com
      </Info>
      <Info> +98930 5014059 </Info>
    </>
  );
};

export default DevInfo;
